import { render, staticRenderFns } from "./Marketplace.vue?vue&type=template&id=0f73ab1a&scoped=true&"
import script from "./Marketplace.vue?vue&type=script&lang=js&"
export * from "./Marketplace.vue?vue&type=script&lang=js&"
import style0 from "./Marketplace.vue?vue&type=style&index=0&id=0f73ab1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f73ab1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f73ab1a')) {
      api.createRecord('0f73ab1a', component.options)
    } else {
      api.reload('0f73ab1a', component.options)
    }
    module.hot.accept("./Marketplace.vue?vue&type=template&id=0f73ab1a&scoped=true&", function () {
      api.rerender('0f73ab1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/CarrierMarketplace/Marketplace.vue"
export default component.exports